import { FC } from "react";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBreakPenalty } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakPenaltyProvider";
import { DurationInput } from "@sinch/components/form/DurationInput/DurationInput";
import { useMuiController } from "@sinch/components/index";

/**
 * Penalty charged for a missed break, only shown once it is set to something else than the break length
 */
export const PenaltyDurationField: FC = () => {
  const { t } = useTranslation();
  const { path, disabled, customPenalty } = useBreakPenalty();
  const { field } = useMuiController<FieldValues, string>({ name: `${path}.penaltyMinutes`, disabled });

  if (!customPenalty) {
    return null;
  }

  return <DurationInput {...field} fullWidth label={t("RateUnit.breakPenaltyDuration")} min={1} />;
};
